import { gql } from '@apollo/client';

// GraphQL mutation to manage training data
export const TRAINING = gql`
mutation createOrUpdateTraining($input: [TrainingInput]) {
  createOrUpdateTraining(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      parent_slug
      name
      photo
      slug
      index
      video_link
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`;


export const TRAINING_CONTENT = gql`
 mutation createOrUpdateTrainingContent($input: [TrainingContentInput]) {
  createOrUpdateTrainingContent(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      chapter_slug
      content
      photo
      deleted
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`;